import React, { useMemo, useState } from 'react';

// Data
import { buildCancelInvite, buildResendInvite, getInvites } from '../../../lib/services/invite.service';
import { INVITE_STATUSES } from '../../../lib/constants';

// Components
import InviteList from './invite-list.component';
import { IFormOption } from '../../_core/_ui/forms.component';
import { getCurrMember } from '../../../lib/services/member.service';
import { ROLES } from '../../../../_configuration';
import { useOperationErrorHandler } from '../../../lib/hooks/use-operation-error-handler';
import { withFailureReport } from '../../../lib/helpers/operation-failure.helpers';
import { messages } from './invite-list.messages';

export const InviteListContainer = () => {
  const { member } = getCurrMember()
  const canInviteToOrganization = useMemo(() => member?.isAdmin || member?.superUserRoles?.includes(ROLES.USER_MANAGEMENT) || false, [member?.isAdmin, member?.superUserRoles])

  const [ageGroup, setAgeGroup] = useState<IFormOption | null>(null);

  const [showSent, setShowSent] = useState<string | null>(null);
  const { resendInvite } = buildResendInvite();
  const { cancelInvite } = buildCancelInvite();
  const reportFailure = useOperationErrorHandler(messages.errCancelNotSaved);
  const reportedCancelInvite = withFailureReport(cancelInvite, reportFailure, 'cancelInvite');

  const { invites } = getInvites(INVITE_STATUSES.PENDING, ageGroup?.value);

  const handleResendInvite = (_id: string) => {
    setShowSent(_id);
    setTimeout(() => {
      setShowSent(null);
    }, 3000);
    resendInvite(_id);
  };

  return <InviteList
    showSent={showSent}
    invites={invites}
    resendInvite={handleResendInvite}
    cancelInvite={reportedCancelInvite}
    ageGroup={ageGroup}
    setAgeGroup={setAgeGroup}
    canInviteToOrganization={canInviteToOrganization}
  />;
};

